import { StackWeb } from '@nucleus/types/web';
import { createContext } from 'react';

export type StacksContextValue = {
  stacks: Map<StackWeb['id'], StackWeb>;
  getStack: (id: StackWeb['id']) => StackWeb | undefined;
};
export const StacksContext = createContext<StacksContextValue>({} as StacksContextValue);
